module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB4003-449c535acbd77ef5b174cf79ba869c0a.png";